import { render, staticRenderFns } from "./UsersPrivilegAdditionalSettings.vue?vue&type=template&id=baed1472&scoped=true&"
import script from "./UsersPrivilegAdditionalSettings.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegAdditionalSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baed1472",
  null
  
)

export default component.exports